import {
  attachMediaPlaybackUnlockOnGesture,
  onMediaPlaybackUnlocked,
} from '@/services/unlockMediaPlayback';

let ringingAudio: HTMLAudioElement | null = null;
let hungUpAudio: HTMLAudioElement | null = null;
let ringingRequested = false;
let ringingUnlockHooked = false;
let ringingGeneration = 0;

function publicSoundUrl(fileName: string): string {
  const pub = (typeof process !== 'undefined' && process.env.PUBLIC_URL
    ? String(process.env.PUBLIC_URL)
    : ''
  ).replace(/\/$/, '');
  const p = `${pub}/sounds/${fileName}`.replace(/\/{2,}/g, '/');
  if (typeof window !== 'undefined' && window.location?.origin) {
    try {
      return new URL(p, window.location.origin).href;
    } catch {
      return p;
    }
  }
  return p;
}

function ensureRingingAudio(): HTMLAudioElement | null {
  if (typeof window === 'undefined') return null;
  if (!ringingAudio) {
    ringingAudio = new Audio(publicSoundUrl('ringing.mp3'));
    ringingAudio.loop = true;
    ringingAudio.preload = 'auto';
  }
  return ringingAudio;
}

function ensureHungUpAudio(): HTMLAudioElement | null {
  if (typeof window === 'undefined') return null;
  if (!hungUpAudio) {
    hungUpAudio = new Audio(publicSoundUrl('hung-up.mp3'));
    hungUpAudio.preload = 'auto';
  }
  return hungUpAudio;
}

function isRingingElementPlaying(a: HTMLAudioElement): boolean {
  return !a.paused && !a.ended;
}

function playRingingNow(): void {
  const a = ensureRingingAudio();
  if (!a || !ringingRequested) return;
  // Same element, already looping — do not rewind (that sounds like a second ringtone).
  if (isRingingElementPlaying(a)) return;
  try {
    a.currentTime = 0;
    void a.play().catch(() => {
      /* autoplay policy */
    });
  } catch {
    /* autoplay policy */
  }
}

/**
 * Incoming ringtone is owned by GlobalIncomingCallBanner.
 * Returns a generation so React Strict Mode cleanup does not kill a remounted start.
 */
export function startIncomingRingingSound(): number {
  attachMediaPlaybackUnlockOnGesture();
  ringingGeneration += 1;
  ringingRequested = true;
  playRingingNow();
  if (!ringingUnlockHooked) {
    ringingUnlockHooked = true;
    onMediaPlaybackUnlocked(() => {
      if (ringingRequested) playRingingNow();
    });
  }
  return ringingGeneration;
}

export function stopIncomingRingingSound(generation?: number): void {
  if (generation != null && generation !== ringingGeneration) return;
  ringingRequested = false;
  if (!ringingAudio) return;
  try {
    ringingAudio.pause();
    ringingAudio.currentTime = 0;
  } catch {
    /* */
  }
}

export function playHangUpSound(): void {
  attachMediaPlaybackUnlockOnGesture();
  const a = ensureHungUpAudio();
  if (!a) return;
  try {
    a.currentTime = 0;
    void a.play().catch(() => {
      /* autoplay policy */
    });
  } catch {
    /* autoplay policy */
  }
}
